import React from 'react'
import { checkTextTranslation, checkTranslation, imageAddress, translate } from '../../utils/useful'
import Modal from '../Modal'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ItemModal from '../../modals/ItemModal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { nanoid } from 'nanoid';
import HttpServices from '../../utils/Http.services';
import SlideView from './SlideView';
import moment from 'jalali-moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// fake data generator
// const getItems = count =>
//     Array.from({ length: count }, (v, k) => k).map(k => ({
//         id: `item-${k}`,
//         content: `item ${k}`
//     }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 10,
    margin: `0 0 ${grid}px 0`,
    // direction: (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) && this.props.data[0]?.direction,

    // change background colour if dragging
    background: isDragging ? "lightblue" : "#f0f0f0",
    borderRadius: 6,
    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#ddd" : "#fff",
    padding: grid,
    width: '100%',
    borderRadius: 8
});



class SlidesInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            headers: [
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
                // { col: '12', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
            ],
            currentViewIndex: 0,
            options: [
                { label: '{{lang}}Static', key: 'static', icon: '/images/carrow.svg' },
                { label: '{{lang}}Dynamic', key: 'dynamic', icon: '/images/carrow.svg' },
                // { label: 'اسلاید ویدیو', key: 'video', icon: '/images/carrow.svg' },
                // { label: 'اسلاید تست', key: 'test', icon: '/images/carrow.svg' },
                // { label: 'اسلاید جواب تست', key: 'testResult', icon: '/images/carrow.svg' },

            ],
            directions: ['ltr', 'rtl'],
            direction: ''
        };
    }
    componentDidMount() {
        let lang = this.props.settings.language
        if (lang == 'fa') {
            this.setState({ direction: 'rtl' })
        } else {
            this.setState({ direction: 'ltr' })

        }
    }
    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.props.data,
            result.source.index,
            result.destination.index
        );

        this.changeInputValue(items)

        this.setState({
            items
        });
    }

    changeInputValue(value) {
        // let value = (target.validity.valid) ? target.value : null
        // if (value !== null) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        // }
    }

    openModal = () => {
        this.modal.showModal()
    }

    openViewModal = () => {
        this.viewModal.showModal()
        this.setState({ currentViewIndex: 0 })
    }
    changeDirection = () => {

        let items = this.props.data
        let pIndex = null
        for (let i = 0; i < this.state.directions.length; i++) {
            const element = this.state.directions[i];
            if (element != this.state.direction) {
                pIndex = i
            }
        }
        this.setState({ direction: this.state.directions[pIndex] }, () => {

            for (let i = 0; i < items.length; i++) {
                const element = items[i];
                element.direction = this.state.direction
            }
            this.changeInputValue(items)
        })

    }

    openSelectOptionsModel = () => {
        this.selectOptionsModal.showModal()

    }


    openNewItem = (type, item, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.selectOptionsModal.hideModal()

        // console.log(item)
        // console.log(prop)

        // let type = item?.type ?? prop.type

        console.log(type)

        this.setState({ currentType: type, currentItem: item, currentIndex: index })

        let headers = []

        if (type == 'static') {
            headers = [
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
                { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: false }, showMain: true, inExport: true },

            ]
        }


        if (type == 'dynamic') {
            headers = [
                // { col: '6', type: 'SelectInput', key: 'dynamicType', information: { label: '{{lang}}Type', type: 'local', items: [{ value: 'date', title: '{{lang}}Date' },{ value: 'docGroup', title: '{{lang}}Documentgroup' },{ value: 'docType', title: '{{lang}}docType' },{ value: 'ProcessType', title: '{{lang}}ProcessType' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },
                { col: '6', type: 'SelectInput', key: 'dynamicType', information: { label: '{{lang}}Type', type: 'local', items: [{ value: 'date', title: '{{lang}}Date' }, { value: 'number', title: '{{lang}}Number' }, { value: 'version', title: '{{lang}}Version' }, { value: 'docGroup', title: '{{lang}}Documentgroup' }, { value: 'docType', title: '{{lang}}docType' }, { value: 'ProcessType', title: '{{lang}}ProcessType' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },
                {
                    col: '6', type: 'SelectInput', key: 'locale', information: { label: '{{lang}}Locale', type: 'local', items: [{ value: 'fa', title: '{{lang}}Solar' }, { value: 'en', title: '{{lang}}Christian' }], isSearchable: true, placeholder: '{{lang}}Select', required: false },
                    dependencies: [{
                        refKey: 'dynamicType',
                        targetKey: 'locale',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'date' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        //refKey
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: true
                },
                {
                    col: '6', type: 'SelectInput', key: 'format', information: { label: '{{lang}}Formate', type: 'local', items: [{ value: 'YYYY', title: '{{lang}}YYYY' }, { value: 'YY', title: '{{lang}}YY' }, { value: 'MMMM', title: '{{lang}}MMMM' }, { value: 'MM', title: '{{lang}}MM' }, { value: 'DD', title: '{{lang}}DD' }, { value: 'YYYY-MM', title: '{{lang}}YYYY-MM' }, { value: 'YY-MM', title: '{{lang}}YY-MM' }, { value: 'YYYY-MMMM', title: '{{lang}}YYYY-MMMM' }, { value: 'YY-MMMM', title: '{{lang}}YY-MMMM' }, { value: 'MM-DD', title: '{{lang}}MM-DD' }, { value: 'MMMM-DD', title: '{{lang}}MMMM-DD' }, { value: 'YY-MM-DD', title: '{{lang}}YY-MM-DD' }, { value: 'YYYY-MM-DD', title: '{{lang}}YYYY-MM-DD' }, { value: 'YYYY-MMMM-DD', title: '{{lang}}YYYY-MMMM-DD' }], isSearchable: true, placeholder: '{{lang}}Select', required: false },
                    dependencies: [{
                        refKey: 'dynamicType',
                        targetKey: 'format',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'date' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        //refKey
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],

                    showMain: true
                },
                // {
                //     type: 'NumberInput', key: 'minNumber', col: '6', information: { label: '{{lang}}Minimum Number', placeholder: '{{lang}}Start From...', required: false },

                //     dependencies: [{
                //         refKey: 'dynamicType',
                //         targetKey: 'minNumber',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'number' } }
                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         //refKey
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: true,
                // },
                // {
                //     type: 'NumberInput', key: 'digits', col: '6', information: { label: '{{lang}}Digits Number', placeholder: '{{lang}}Number Of Digits...', required: false },

                //     dependencies: [{
                //         refKey: 'dynamicType',
                //         targetKey: 'digits',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'number' } }
                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         //refKey
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: true,
                // },
                // { col: '12', key: 'key', type: 'TextInput', information: { label: '{{lang}}Key For Auto Generation', disabled: false, required: false },
                // dependencies: [{
                //     refKey: 'dynamicType',
                //     targetKey: 'key',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'and',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'number' } }
                //             }
                //         },
                //     },
                //     show: true,
                //     init: true,
                //     //refKey
                //     // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                // }],
                // showMain: true, inExport: true },
                {
                    type: 'NumberInput', key: 'levels', col: '6', information: { label: '{{lang}}Group levels', placeholder: '{{lang}}To Level...', required: false },

                    dependencies: [{
                        refKey: 'dynamicType',
                        targetKey: 'levels',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'docGroup' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        //refKey
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: true,
                },
                {
                    type: 'TextInput', key: 'seperator', col: '6', information: { label: '{{lang}}Seperator', placeholder: '{{lang}}Seperator', required: false },

                    dependencies: [{
                        refKey: 'dynamicType',
                        targetKey: 'seperator',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.dynamicType' }, operator: { value: '==' }, target: { value: 'docGroup' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        //refKey
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: true,
                },


                // { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: false }, showMain: true, inExport: true },
                // { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', disabled: false, required: true }, showMain: true, inExport: true },
                // { col: '12', key: 'audio', type: 'FileInput', information: { label: '{{lang}}Audio file', disabled: false, required: true }, showMain: true, inExport: true },
            ]
        }

        if (type == 'video') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'video', type: 'FileInput', information: { label: '{{lang}}Video file', disabled: false, required: true }, showMain: true, inExport: true },
            ]
        }

        if (type == 'test') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'question', type: 'TextInput', information: { label: '{{lang}}Question_', disabled: false, required: true }, showMain: true, inExport: true },
                {
                    type: 'SubformInput',
                    key: 'options',
                    col: '12',
                    information: {
                        headers: [
                            { type: 'TextInput', key: 'name', col: '8', information: { label: '{{lang}}Option', placeholder: '{{lang}}Option', required: true }, showMain: true, },
                            { type: 'NumberInput', key: 'score', col: '4', information: { label: '{{lang}}Option score', placeholder: '{{lang}}Option score', required: true }, showMain: true, },
                        ],
                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false,
                    },
                    showMain: true
                },
            ]
        }

        if (type == 'testResult') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: false }, showMain: true, inExport: true },
                {
                    type: 'SubformInput',
                    key: 'options',
                    col: '12',
                    information: {
                        headers: [
                            { type: 'NumberInput', key: 'score', col: '8', information: { label: '{{lang}}Result explanation', placeholder: '{{lang}}Result explanation', required: true }, showMain: true, },
                            { type: 'NumberInput', key: 'result', col: '4', information: { label: '{{lang}}Total score', placeholder: '{{lang}}Total score', required: true }, showMain: true, },

                        ],
                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false,
                    },
                    showMain: true
                },
            ]
        }



        let colorHeaders = [
            { col: '12', key: 'backgroundColor', type: 'ColorGradientInput', information: { label: 'رنگ پس زمینه', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'backgroundImage', type: 'ImageInput', information: { label: 'تصویر پس زمینه', disabled: false, single: true, cropper: true, ratio: '9:16', required: false }, showMain: true, inExport: true },
            { col: '12', key: 'textColor', type: 'ColorInput', information: { label: 'رنگ متن', disabled: false, single: true, cropper: true, ratio: '9:16', required: false }, showMain: true, inExport: true },
        ]


        let finalHeaders = [...headers]

        this.setState({ headers: finalHeaders })
        // if()
        // let items = this.props.data
        // items.push({ type: 'text', id: nanoid() })
        // this.setState({ items })
    }



    addNewItem = () => {
        // this.selectOptionsModal.hideModal()

        let items = this.props.data
        items.push({ type: this.state.currentType, id: nanoid() })
        this.setState({ items })
    }
    showSample = () => {

        let sample = ''
        if (this.props.data) {

            for (let i = 0; i < this.props.data.length; i++) {
                const data = this.props.data[i];
                if (data.type == 'static') {
                    sample = sample + data.title
                } else {
                    if (data.dynamicType == 'date') {
                        sample = sample + String(moment().locale(data.locale).format(data.format))

                    } else if (data.dynamicType == 'number') {
                        sample = sample + '001'
                    } else if (data.dynamicType == 'docGroup') {
                        for (let i = 0; i < data.levels; i++) {
if(i<data.levels-1){

    sample = sample + '[DG]' + data.seperator
}else{
    sample = sample + '[DG]' 

}

                        }

                    } else if (data.dynamicType == 'docType') {
                        sample = sample + '[DT]'

                    } else if (data.dynamicType == 'ProcessType') {
                        sample = sample + '[PT]'

                    }else if (data.dynamicType == 'version') {
                        sample = sample + '01'

                    }
                }
            }

        } else {
            sample = translate('Click To Add Code')
        }
        return sample
    }

    submitForm = (data) => {


        // console.log(data)

        this.setState({ isPostingData: true, })
        HttpServices.handleFiles(null, data, () => {

            this.setState({ isPostingData: false })

            // console.log(data)
            let slides = this.props.data
            // console.log(slides)
            if (!Array.isArray(slides)) {
                slides = []
            }

            data.id = nanoid()
            data.type = this.state.currentType

            // console.log(this.state.currentType)

            if (this.state.currentIndex != null) {
                slides[this.state.currentIndex] = data
            } else {
                slides.push(data)
            }

            this.itemModal.modal.hideModal()

            this.changeInputValue(slides)

            this.setState({ currentItem: null })
        })


    }

    removeItem = (index) => {
        let slides = this.props.data
        slides.splice(index, 1)
        this.changeInputValue(slides)

    }


    render() {

        var sliderSettings = {
            dots: true,
            autoplay: false,
            autoplaySpeed: 2500,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false

        };

        return (
            <div className="w-100 h-100" >
                {/* <input  ref={el => this.input = el} spellCheck={this.props.header.information.spellCheck} value={this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} disabled={this.props.disabled || this.props.header.information?.disabled} className="transpanet-input" /> */}
                <p style={{ direction: (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) && this.props.data[0]?.direction }} onClick={() => this.openModal()} className='cursor-pointer '>{this.showSample()} </p>

                <Modal ref={el => this.modal = el} maxWidth={600}>
                    <div className='px-3 pt-3' style={{ direction: (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) && this.props.data[0]?.direction, backgroundColor: '#fff', borderRadius: 8, paddingBottom: 100 }}>
                        <div className='px-2 w-100 flexcb'>
                            <p className='text-right mb-3 mt-2' style={{ fontSize: 18 }}>{translate('Codes')}</p>
                            {this.props.data && (

                                <button onClick={() => this.changeDirection()} className=' py-2 px-3' style={{ backgroundColor: '#246ac7', color: '#fff', borderRadius: 6 }}>
                                    <p className='' style={{ fontWeight: 500, fontSize: 14 }}>{translate('Change Direction')}</p>
                                </button>
                            )}
                            <button onClick={() => this.openViewModal()} className=' py-2 px-3' style={{ backgroundColor: '#246ac7', color: '#fff', borderRadius: 6 }}>
                                <p className='' style={{ fontWeight: 500, fontSize: 14 }}>{translate('Show sample')}</p>
                            </button>
                        </div>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {this.props.data?.map((item, index) => {
                                            // console.log(item.id)
                                            let levels = []
                                            if(item.levels){

                                                levels  = Array.from({ length: item.levels }, (_, index) => index)
                                            }
                                            return (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}
                                                        >
                                                            <div className='w-100 flexc'>

                                                                {/* <div>
                                                                    <div className=' d-flex flex-column' style={{ height: 60, width: 60, borderRadius: 40, background: (item.backgroundImage ? ("url(" + imageAddress(item.backgroundImage) + ")") : (item.backgroundColor ?? 'linear-gradient(#FF3B30, #ff3030)')), backgroundSize: 'cover', backgroundPosition: 'center', }}>

                                                                    </div>
                                                                </div> */}


                                                                <div className='pr-2 w-100'>

                                                                    <div className='flexcb'>

                                                                        {item.title ? (
                                                                            <div className='mt-1' style={{ flex: 1 }}>
                                                                                <p className='text-small text-bold text-bold'>{item.title}</p>
                                                                            </div>
                                                                        ) : (
                                                                            item.dynamicType == 'date' ? (

                                                                                <div>
                                                                                    <p className='text-small text-bold text-bold'>{moment().locale(item.locale).format(item.format)}</p>

                                                                                </div>
                                                                            ) : item.dynamicType == 'number' ? (
                                                                                <div>
                                                                                    <p className='text-small text-bold text-bold'>001</p>
                                                                                </div>
                                                                            ) : item.dynamicType == 'version' ? (
                                                                                <div>
                                                                                    <p className='text-small text-bold text-bold'>01</p>
                                                                                </div>
                                                                            ):item.dynamicType == 'docGroup' ? (
                                                                                <div className='flexc'>
                                                                                    {levels?.map((xx, i) => {
                                                                                        if(i < levels.length-1){

                                                                                            return (
                                                                                                <p className='text-small text-bold text-bold'>{`[DG]${item.seperator}`}</p>
                                                                                            )
                                                                                        }else{
                                                                                            return (
                                                                                                <p className='text-small text-bold text-bold'>{`[DG]`}</p>
                                                                                            )

                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            ) : item.dynamicType == 'docType' ? (
                                                                                <div>
                                                                                    <p className='text-small text-bold text-bold'>[DT]</p>
                                                                                </div>

                                                                            ) : item.dynamicType == 'ProcessType' && (
                                                                                <div>
                                                                                    <p className='text-small text-bold text-bold'>[PT]</p>
                                                                                </div>

                                                                            )
                                                                        )}


                                                                        <div className='flexc'>



                                                                            <button className='mx-1 p-0 flexcc'>
                                                                                <img src={'/images/remove.svg'} height={20} onClick={() => this.removeItem(index)} />
                                                                            </button>

                                                                            <button className='mx-1 p-0 flexcc' onClick={() => this.openNewItem(item.type, item, index)}>
                                                                                <img src={'/images/inputdef.svg'} height={20} />
                                                                            </button>

                                                                            {item.type && (
                                                                                <div className='mx-1  d-flex'>
                                                                                    <div className='px-3 py-1' style={{ backgroundColor: '#fff', borderRadius: 40 }}>
                                                                                        <p className='text-smaller '>{translate(item.type)}</p>
                                                                                    </div>
                                                                                </div>
                                                                            )}



                                                                        </div>

                                                                    </div>

                                                                    {item.question && (
                                                                        <div className='text-smaller mt-1' style={{ flex: 2 }}>
                                                                            <p>{item.question}</p>
                                                                        </div>

                                                                    )}

                                                                    {item.description && (
                                                                        <div className='text-smaller mt-1' style={{ flex: 2 }}>
                                                                            <p>{item.description}</p>
                                                                        </div>

                                                                    )}
                                                                </div>
                                                                {/* <div style={{ flex: 3 }}>
                                                                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugiat labore reprehenderit temporibus quae placeat aliquam neque aut eligendi eius, ullam sequi iste nam excepturi commodi impedit fugit vero ducimus praesentium.
                                                                </div> */}
                                                                {/* {item.content} */}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )
                                        }
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>


                        </DragDropContext>


                        {this.props.data?.length == 0 && (
                            <p className='text-center'>در حال حاضر اسلایدی برای این اپیزود موجود نمی باشد</p>
                        )}
                        <div className='px-2 w-100 mt-4'>
                            <button className=' py-2 px-3 w-100' onClick={() => this.openSelectOptionsModel()} style={{ backgroundColor: '#246ac7', color: '#fff', borderRadius: 6 }}>
                                <p className='text-bold ' style={{ fontWeight: 500, fontSize: 18 }}>{translate('Add New Code')}</p>
                            </button>
                        </div>


                    </div>
                </Modal>


                <Modal ref={el => this.selectOptionsModal = el} maxWidth={250}>
                    <div className='px-3 pt-3' style={{ direction: (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) && this.props.data[0]?.direction, backgroundColor: '#fff', borderRadius: 8, paddingBottom: 20 }}>
                        <p className='mb-4'>{translate('What Kind Of Code You Want To Add?')}</p>
                        {this.state.options.map((prop, index) => {
                            return (
                                <button onClick={() => this.openNewItem(prop.key)} className='flexc w-100 pb-3 mb-2' style={{ fontSize: 18, borderBottom: '1px solid #f2f2f2' }}>
                                    <img className='reverse' height={16} src={prop.icon} />
                                    <p className='mx-2'>{checkTranslation(prop.label)}</p>
                                </button>
                            )
                        })}
                    </div>
                </Modal>


                <Modal ref={el => this.viewModal = el} maxWidth={350} dontHideOnOverlay={true}>
                    <div className='px-3 pt-3' style={{ direction: (this.props.data && Array.isArray(this.props.data) && this.props.data[0]) && this.props.data[0]?.direction, backgroundColor: '#fff', borderRadius: 8, paddingBottom: 50 }}>

                        <p className='text-bold mx-2'>{this.showSample()}</p>
                    </div>
                </Modal>

                {console.log('sliddthis.props.variables', this.props.variables)}
                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.page}
                    headers={this.state.headers}
                    variables={this.props.variables}
                    initData={this.state.currentItem}
                    submitForm={this.submitForm}
                    isPostingData={this.state.isPostingData}
                />


            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(SlidesInput);
